<template>
  <div id="discover" class="product-discover-component">
    <div class="container">
      <div class="row">
        <div
          v-if="productProvenDescSlot || productToleranceDescSlot"
          class="col-md-4 visible-md visible-lg"
        >
          <div class="product-discover-section">
            <div
              v-if="productBenefitsDescSlot"
              class="product-discover-collapsable collapsible product-discover-section-benefits"
            >
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productBenefitsTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productBenefitsDesc"></slot>
              </div>
            </div>
            <div v-if="productProvenDescSlot" class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productProvenTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productProvenDesc"></slot>
              </div>
            </div>
            <div v-if="productToleranceDescSlot" class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productToleranceTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productToleranceDesc"></slot>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="productProvenDescSlot || productToleranceDescSlot || productBenefitsDescSlot"
          class="col-md-4 hidden-md hidden-lg"
        >
          <div class="product-discover-section">
            <div
              v-if="productBenefitsDescSlot"
              class="product-discover-collapsable collapsible product-discover-section-benefits"
            >
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productBenefitsTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productBenefitsDesc"></slot>
              </div>
            </div>
            <div v-if="productProvenDescSlot" class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productProvenTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productProvenDesc"></slot>
              </div>
            </div>
            <div v-if="productToleranceDescSlot" class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productToleranceTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <slot name="productToleranceDesc"></slot>
              </div>
            </div>
          </div>
        </div>
        <div v-if="productButtonLink != ''" class="col-md-4">
          <div class="product-discover-Ingredients-section">
            <div class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <div data-ioplist="">
                  <h3>{{ productIngredientsTitle }}</h3>
                </div>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <h2 class="product-discover-Ingredients-header">{{ productIngTitle }}</h2>
                <div class="product-discover-Ingredients-image">
                  <img class="lazyload" :alt="productImageAlt" :data-src="productImage" />
                </div>
                <div v-if="productButtonTitle != ''" class="mixa-redesign-footer-common-btn">
                  <a
                    :href="productButtonLink"
                    role="button"
                    class="btn-primary mixa-redesign-footer-btn"
                  >
                    <strong>{{ productButtonTitle }}</strong>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="product-discover-usage-section">
            <div v-if="productUseDescSlot" class="product-discover-collapsable collapsible">
              <div class="product-discover-section-header collapsible-header">
                <h3>{{ productUseTitle }}</h3>
                <div class="collapsible-button">
                  <svg class="icon button-plus"><use xlink:href="#acco_down_blue"></use></svg>
                  <svg class="icon button-minus hidden"><use xlink:href="#acco_up_blue"></use></svg>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <div class="product-discover-usage-content">
                  <slot name="productUseDesc"></slot>
                </div>
              </div>
            </div>
            <div
              v-if="productViewDescSlot"
              class="product-discover-collapsable product-discover-composition collapsible"
            >
              <div class="product-discover-composition-header collapsible-header">
                <div class="collapsible-button">
                  <svg class="icon"><use xlink:href="#arrow-right"></use></svg>
                </div>
                <div class="product-discover-composition-collapse">
                  <h3>{{ productViewTitle }}</h3>
                </div>
              </div>
              <div class="product-discover-section-content collapsible-content">
                <div class="product-discover-usage-content">
                  <slot name="productViewDesc"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'mixa-product-redesign',
  props: {
    productBenefitsTitle: {
      type: String,
      required: false,
    },
    productProvenTitle: {
      type: String,
      required: false,
    },
    productToleranceTitle: {
      type: String,
      required: false,
    },
    productIngredientsTitle: {
      type: String,
      required: false,
    },
    productIngTitle: {
      type: String,
      required: false,
    },
    productButtonTitle: {
      type: String,
      required: false,
    },
    productButtonLink: {
      type: String,
      required: false,
    },
    productUseTitle: {
      type: String,
      required: false,
    },
    productViewTitle: {
      type: String,
      required: false,
    },
    productImage: {
      type: String,
      required: false,
    },
    productImageAlt: {
      type: String,
      required: false,
    },
  },
  computed: {
    productViewDescSlot() {
      return !!this.$slots.productViewDesc;
    },
    productUseDescSlot() {
      return !!this.$slots.productUseDesc;
    },
    productToleranceDescSlot() {
      return !!this.$slots.productToleranceDesc;
    },
    productProvenDescSlot() {
      return !!this.$slots.productProvenDesc;
    },
    productBenefitsDescSlot() {
      return !!this.$slots.productBenefitsDesc;
    },
  },
};
</script>
